import http from "@/service/http";
import React from "react";

export const OrderContext = React.createContext({});
export const useOrder = () => React.useContext(OrderContext);

export default {
  /**
   * 获取订单列表
   */
  getOrders({ type, page, per_page }) {
    return http
      .get(`/member/orders`, {
        params: {
          type: type || "all",
          page: page || 1,
          per_page: per_page || 8,
        },
      })
      .then((res) => {
        return {
          data: res.data,
          page_info: {
            page: res.headers.current_page,
            total: res.headers.total_count,
            pages: res.headers.total_pages,
          },
        };
      });
  },
  /**
   * 创建订单
   */
  async createOrder({
    voucher_codes = [],
    restaurant_id,
    deal_id,
    project,
    source = '',
    quantity = 1,
    comment = "",
  }) {
    return http
      .post(`/member/orders`, {
        project: project || "diningcity",
        voucher_codes,
        restaurant_id,
        deal_id,
        platform: "web",
        source,
        quantity,
        comment,
      })
      .then((res) => this.getOrderById(res.data.uuid));
  },
  /**
   * 取消订单
   */
  cancelOrder(uuid) {
    return http.post(`/public/orders/${uuid}/cancel`).then((res) => res.data);
  },
  /**
   * 获取订单信息，同时查询套餐和餐厅详情
   * @param {*} uuid
   * @returns
   */
  async getOrderInfo(uuid) {
    try {
      let order = await this.getOrderById(uuid);
      let restaurant = await this.getRestaurantById(order.restaurant.id);
      let deal = await this.getDealById(order.deal_id);
      return {
        order,
        restaurant,
        deal,
      };
    } catch (error) {
      console.error(error)
      return null;
    }
  },
  /**
   * 查看订单详情
   */
  async getOrderById(uuid) {
    return http.get(`/public/orders/${uuid}`).then((res) => res.data);
  },
  async getDealById(deal_id) {
    if (!deal_id) return null;
    return http
      .get(`/public/deals/${deal_id}`)
      .then((res) => res.data)
      .catch((err) => null);
  },
  async getRestaurantById(restaurant_id) {
    if (!restaurant_id) return null;
    return http
      .get(`/public/restaurants/${restaurant_id}`)
      .then((res) => res.data)
      .catch((err) => null);
  },
};

export const mock = {
  createOrder: {
    id: 4011,
    status: "redeemed",
    status_humanize: "待支付",
    datetime: null,
    formated_datetime: null,
    formated_paid_at: null,
    uuid: "c36c5bdf08824810981795af737a71ec",
    tax: "0.0",
    delivery_fee: "0.0",
    total_fee: "176.0",
    can_cancel: true,
    can_change_channel: false,
    estimated_delivery_datetime: null,
    formated_created_at: "2025年5月21日 11:23",
    formated_estimated_delivery_datetime: null,
    format_fee: "￥176",
    total_amount: "176.0",
    format_total_amount: "￥176",
    book_id: null,
    deeplink_url: null,
    website_qr_code:
      "https://api.diningcity.asia/public/qr_code/render_png?text=https%3A%2F%2Fstaging-book.diningcity.asia%2F%23%2Fpos-pay%3Forder_id%3D4011%26reservation_code%3D%26book_id%3D",
    start_at: "2025-05-19T00:00:00.000+08:00",
    end_at: "2026-10-28T00:00:00.000+08:00",
    checked_at: null,
    voucher_amount: "0.0",
    format_voucher_amount: "￥0",
    code: "DC20250521112356R",
    quantity: 2,
    deal_id: 10247,
    page_status: "successful",
    page_status_humanize: "待支付",
    payment: {
      id: 14257,
      uuid: "20250521112356370xhyi",
      channel: null,
      channel_humanize: null,
      expire_at: "2025-05-21T11:38:56.000+08:00",
      price: 176,
      format_price: "￥176",
      channels: "amexweb,uac_alipay,uac_upacp,uac_pay,wx",
      status: "pending",
      status_humanize: "待支付",
    },
    restaurant: {
      id: 2049023,
      name: "红酒西餐厅 (建国西路店)",
      cover:
        "https://static-assets.diningcity.asia/restaurantpictures/2018/2ad0b17545522740c6f801b360b2c09e.jpeg",
      phone: "021-64338806",
      dirname: "chateau_dionne_shanghai",
    },
    booking: null,
    delivery: null,
    qr_code: {
      key: "19c3440b6cd60ee4",
      qrcode_url:
        "https://staging-api.diningcity.asia/public/qr_code/render_png?text=https://staging-api.diningcity.asia/public/qr_codes/19c3440b6cd60ee4&size=",
      scanned_at: null,
      action: "open_order_walk_in",
      args: {
        order_id: 4011,
        book_id: null,
        reservation_code: null,
      },
      is_scanned: false,
    },
    items: [
      {
        fee: "176.0",
        quantity: 2,
        title: "walkin deal set",
        format_fee: "￥176",
        product_type: "DealsProject",
        entity: null,
      },
    ],
    operations: {
      can_cancel: true,
      can_redeem: false,
      can_refund: false,
      can_pay: true,
    },
  },
  orderDetails: {
    id: 7,
    status: "pending",
    status_humanize: "待支付",
    datetime: null,
    formated_datetime: null,
    formated_paid_at: null,
    uuid: "314946dfe5154f68a4ec9d696cad6876",
    tax: "0.0",
    delivery_fee: "0.0",
    total_fee: "100.0",
    can_cancel: false,
    can_change_channel: false,
    estimated_delivery_datetime: null,
    formated_created_at: "2025年5月16日 17:21",
    formated_estimated_delivery_datetime: null,
    format_fee: "￥100",
    total_amount: "0.0",
    format_total_amount: "￥0",
    book_id: null,
    deeplink_url: null,
    website_qr_code:
      "https://api.diningcity.asia/public/qr_code/render_png?text=https%3A%2F%2Fstaging-book.diningcity.asia%2F%23%2Fpos-pay%3Forder_id%3D7%26reservation_code%3D%26book_id%3D",
    start_at: null,
    end_at: null,
    checked_at: null,
    voucher_amount: 0,
    code: "DC20250516172148U",
    quantity: null,
    deal_id: null,
    can_redeem: false,
    payment: {
      id: 7,
      uuid: "20250516172148664jaks",
      channel: null,
      channel_humanize: null,
      expire_at: "2025-05-16T17:36:48.000+08:00",
      price: 100,
      format_price: "100",
      channels: "wx,alipay",
      status: "pending",
      status_humanize: "待支付",
    },
    restaurant: {
      id: 171,
      name: "",
      cover:
        "https://static-assets.diningcity.asia/restaurantpictures/restaurant_picture.png",
      phone: "139",
      dirname: "Gabriela Roberts",
    },
    booking: null,
    delivery: null,
    qr_code: {
      key: "374fa8fb17965d5a",
      qrcode_url:
        "https://api.diningcity.asia/public/qr_code/render_png?text=https://api.diningcity.asia/public/qr_codes/374fa8fb17965d5a&size=",
      scanned_at: null,
      action: "open_order_pospay",
      args: {
        order_id: 7,
        book_id: null,
        reservation_code: null,
      },
      is_scanned: false,
    },
    items: [
      {
        fee: "100.0",
        quantity: 1,
        title: "deal name",
        format_fee: "￥100",
        product_type: "VoucherBatch",
        entity: {
          id: 295,
          code: "az4mcj",
          start_at: "2025-05-16T00:00:00.000+08:00",
          end_at: "2025-06-16T23:59:59.000+08:00",
          project: "diningcity",
          points: 1,
          used: false,
          expired: false,
          can_refund: false,
          applicable: null,
          project_config: {
            title: "",
            project_type: "normal",
          },
          detail: {
            title: "deal name",
            desc: null,
            id: 25,
            name: "deal name",
            code_length: 6,
            points_type: "fixed",
            points_type_humanize: "固定次数",
            price: "100",
            currency: "￥",
            points: 1,
            amount: 0,
            start_on: "2025年5月16日",
            end_on: "2025年6月16日",
            value: null,
            type: "VoucherBatch",
            stock_count: -1,
            voucher_per_seat: 1,
            price_type: null,
            batch_code: null,
            price_humanize: "",
            visible_consumer: true,
            validity_num: null,
            validity_unit: null,
            use_type: "book",
            deal: {
              id: 55,
              name: "deal name",
              picture_url:
                "https://assets.diningcity.cn/default-placeholder.png",
            },
            voucher_batch_assignment: null,
          },
        },
      },
    ],
  },
  list: [
    {
      id: 1,
      status: "pending",
      status_humanize: "Pending",
      datetime: null,
      formated_datetime: null,
      uuid: "604e815824a34c208f538c326bb70983",
      formated_paid_at: null,
      formated_estimated_delivery_datetime: null,
      total_amount: "0.0",
      book_id: null,
      deeplink_url: null,
      can_cancel: false,
      can_redeem: false,
      payment: {
        id: 1,
        uuid: "2025051617185258672kf",
        channel: null,
      },
      restaurant: {
        id: 65,
        name: "",
        cover:
          "https://static-assets.diningcity.asia/restaurantpictures/restaurant_picture.png",
        dirname: "Adelaida Cruickshank",
      },
      booking: null,
    },
  ],
};
